export default __webpack_public_path__ + "static/media/check-white.73cb10ce.svg";